import { NotificationType, notify } from 'src/providers/NotificationProvider'

import { PlanterRegistrationValues } from 'src/components/organisms/forms/PlanterRegistrationForm/types'

import {
  AssetType,
  CreatePlanterRegistrationAssetMutationFn,
  DeletePlanterRegistrationAssetMutationFn
} from 'src/config/generated/graphql'
import { S3Asset } from 'src/types/form'
import { buildAssetsDiff } from 'src/utils/assets'
import { UploadAssetType, uploadFilesToS3 } from 'src/utils/fileUpload'

export const createAndDeleteAssets = async ({
  id,
  existingAssets = [],
  onCreatePlanterRegistrationAsset,
  onDeletePlanterRegistrationAsset,
  values
}: {
  id: string
  existingAssets: S3Asset[]
  onCreatePlanterRegistrationAsset: CreatePlanterRegistrationAssetMutationFn
  onDeletePlanterRegistrationAsset: DeletePlanterRegistrationAssetMutationFn
  values: PlanterRegistrationValues
}) => {
  const planterRegistrationAssetsToDelete = buildAssetsDiff(existingAssets, [
    ...(values.PlantingAssets as S3Asset[]),
    ...(values.PlantingDocuments as S3Asset[])
  ])

  if (planterRegistrationAssetsToDelete.length) {
    planterRegistrationAssetsToDelete.forEach(async atd => {
      if ((atd as S3Asset).Id) {
        await onDeletePlanterRegistrationAsset({
          variables: {
            id: (atd as S3Asset).Id,
            planterRegistrationId: id
          }
        })
      }
    })
  }

  // Creating planter registration assets
  const planterRegistrationAssetsToCreate = buildAssetsDiff(
    values.PlantingAssets as S3Asset[],
    existingAssets as S3Asset[]
  )
    .map(pa => ({ file: pa, type: AssetType.Image }))
    .concat(
      buildAssetsDiff(
        values.PlantingDocuments as S3Asset[],
        existingAssets as S3Asset[]
      ).map(pa => ({ file: pa, type: AssetType.SupportingDocument }))
    )

  if (planterRegistrationAssetsToCreate.length) {
    try {
      await uploadFilesToS3(
        onCreatePlanterRegistrationAsset,
        planterRegistrationAssetsToCreate,
        UploadAssetType.PlanterRegistration,
        id
      )
    } catch (error: any) {
      notify({ message: error.message, type: NotificationType.error })
    }
  }
}
